import {
	Component,
	OnInit,
	Inject,
	ViewEncapsulation,
	OnDestroy,
	ElementRef,
	ViewChild,
	HostListener,
	AfterViewInit,
	Renderer2,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
// SERVICES
import { AuthenticationConfigurationService } from '@services/authentication/authentication-configuration.service';
// MODELS
import { FILE_TYPE } from '@constants/FileType';
import { MultimediaContent } from '@models/Multimedia';
import { MinifiedContent } from '@models/content/Content';
import { isAudioFile, isLinkFile, isPDFFile, isVideoFile } from '@utils/file-type';
import { Subscription } from 'rxjs';
import { environment } from '@env/environment';
import Player from '@vimeo/player';
import { SYSTEMS } from '@constants/System';
import { includes } from 'lodash';
import { ResourceService } from '@services/resource/resource.service';

// TODO : TAG GTM
declare var dataLayer: any;

@Component({
	selector: 'ui-multimedia-dialog',
	templateUrl: './multimedia-dialog.html',
	styleUrls: ['./multimedia-dialog.scss'],
	encapsulation: ViewEncapsulation.None,
	host: {
		class: 'wrapper-multimedia-dialog',
	},
})
export class UIMultimediaDialog implements OnInit, OnDestroy, AfterViewInit {
	subscription = new Subscription();
	content: MinifiedContent;
	rol = '';
	isDownloadSound: boolean = false;
	@ViewChild('videoFrame') videoFrame!: ElementRef;
	options: any;
	player: any;
	systemId!: number;
	nodeId: number;
	grade: number;
	subsystem: number;
	cct: string | null = '';
	typeSchool: string | null = '';
	constructor(
		public dialogRef: MatDialogRef<UIMultimediaDialog>,
		private authConfigService: AuthenticationConfigurationService,
		@Inject(MAT_DIALOG_DATA) public multimedia: MultimediaContent,
		private renderer: Renderer2,
		private el: ElementRef,
		private rs: ResourceService
	) {
		this.content = multimedia.data;
		this.nodeId = Number(multimedia.nodeId);
		this.grade = Number(multimedia.grade);
		this.subsystem = Number(multimedia.subsystem);
		console.error('NODO ID');
		console.log(this.grade);

		if (this.content.fileTypeId == 5) {
			if (this.content.fileTypeDesc === 'Webinars') {
				multimedia.showButtonDownload = false;
			}
			dataLayer.push({
				event: 'loading_time_resource', //Static data
				account_type: this.rol, //Dynamic data
				content_group: 'Recursos digitales', //Dynamic data
				loading_time: 0, //Dynamic data
				visible: 'TRUE', //Dynamic data
				subject: this.content.formativeFieldDescription, //Dynamic data
				video_title: this.content.name, //Dynamic data
				video_duration: 0, //Dynamic data
				file_name: this.content.description, //Dynamic data
				cct: this.cct, //Dynamic data
				school_type: this.typeSchool,
			});
		}
		this.getUser();
	}

	ngOnInit() {
		this.cct = localStorage.getItem('cct');
		this.typeSchool = localStorage.getItem('typeSchool');
		this.systemId = this.authConfigService.getSystemId;
		console.log(this.systemId);
		let ids = [
			1836, 1839, 1848, 1857, 2187, 2575, 2189, 2576, 3131, 3651, 3654, 3663, 3672, 3223,
			3224,
		];
		let idsSubsystem = [4454];
		let idsGrade = [4404, 4567, 4558];
		this.isDownloadSound =
			(this.systemId === 2 || this.systemId === 4) &&
			(ids.includes(this.nodeId) ||
				idsSubsystem.includes(this.subsystem) ||
				idsGrade.includes(this.grade));
	}

	ngAfterViewInit() {
		if (this.showVideo()) {
			this.options = {
				id: 'https://player.vimeo.com/video/' + this.content.urlContent,
				responsive: true,
				loop: false,
			};

			this.player = new Player('vimeo-video', this.options);
			this.player.on('play', () => {
				dataLayer.push({
					event: 'video_start',
					account_type: this.rol,
					content_group: 'Recursos digitales',
					grade: 'Primaria',
					subject: 'Recursos digitales',
					video_title: this.content.name,
					video_id: this.content.urlContent,
					visible: true,
					cct: this.cct, //Dynamic data
					school_type: this.typeSchool,
				});
			});
			this.player.on('pause', (res: any) => {
				dataLayer.push({
					event: 'video_progress',
					account_type: this.rol,
					content_group: 'Recursos digitales',
					grade: 'Primaria',
					subject: 'Recursos digitales',
					video_title: this.content.name,
					video_id: this.content.urlContent,
					visible: true,
					cct: this.cct, //Dynamic data
					school_type: this.typeSchool,
				});
			});
			this.player.on('ended', () => {
				dataLayer.push({
					event: 'video_complete',
					account_type: this.rol,
					content_group: 'Recursos digitales',
					grade: 'Primaria',
					subject: 'Recursos digitales',
					video_title: this.content.name,
					video_id: this.content.urlContent,
					visible: true,
					cct: this.cct, //Dynamic data
					school_type: this.typeSchool,
				});
			});
		}
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

	descargar(urlMp3: string) {
		const link = document.createElement('a');
		link.href = urlMp3;
		link.download = 'archivo.mp3';
		link.click();
	}
	getUser() {
		this.subscription.add(
			this.authConfigService.currentUser.subscribe((x) => {
				this.rol = x?.rol || '';

				dataLayer.push({
					event: 'view_content_resource', //Static data
					account_type: this.rol, //Dynamic data
					content_group: 'Recursos digitales', //Dynamic data
					subject: this.content.formativeFieldDescription, //Dynamic data
					content_name: this.content.description, //Dynamic data
					content_type: this.content.fileTypeDesc, //Dynamic data
					content_list_id: this.content.id, //Dynamic data
					cct: this.cct, //Dynamic data
					school_type: this.typeSchool,
				});
			})
		);
	}

	showAudio() {
		return isAudioFile(this.multimedia.data.fileTypeId);
	}

	showVideo() {
		return isVideoFile(this.multimedia.data.fileTypeId);
	}

	showDocument() {
		return (
			isPDFFile(this.multimedia.data.fileTypeId) &&
			!this.multimedia.data.urlContent.includes('.docx') &&
			!this.multimedia.data.urlContent.includes('.pptx')
		);
	}

	showLink() {
		return (
			isLinkFile(this.multimedia.data.fileTypeId) ||
			this.multimedia.data.urlContent.includes('.docx') ||
			this.multimedia.data.urlContent.includes('.pptx')
		);
	}

	getUrlMultimedia() {
		switch (this.multimedia.data.fileTypeId) {
			case FILE_TYPE.videos:
				return 'https://player.vimeo.com/video/' + this.content.urlContent;
			case FILE_TYPE.audios:
			case FILE_TYPE.presentations:
				return this.content.urlContent;
			default:
				return this.content.urlContent;
		}
	}

	canDownloadDocument() {
		const email = sessionStorage.getItem('email');
		const showOption = email === 'usuarioprueba@hachette.com.mx' ? true : false;
		return showOption ? false : this.multimedia.data.fileTypeId !== FILE_TYPE.textBooks;
	}

	getUrlPdf() {
		return `${environment.hostAPI}/contents/${this.multimedia.data.id!}/download`;
	}

	getFileName() {
		let fileName =this.content.urlContent.replace(/^.*[\\/]/, '');
		if(fileName.includes('.pdf_sv=') || fileName.includes('.pdf?sv=')){
			fileName = this.content.name + '.pdf';
		}
		return fileName;
	}

	closeDialog() {
		this.dialogRef.close();
	}

	onPlayAudio() {
		this.eventGTM();
	}

	eventGTM() {
		dataLayer.push({
			event: 'audio_start',
			account_type: this.rol,
			content_group: 'Recursos digitales',
			// level: "example",
			grade: 'Primaria',
			subject: 'Recursos digitales',
			audio_title: this.content.name,
			audio_duration: 0,
			visible: true,
			cct: this.cct, //Dynamic data
			school_type: this.typeSchool,
		});
	}
	videoPlay(event: Event) {
		dataLayer.push({
			event: 'video_start',
			account_type: this.rol,
			content_group: 'Recursos digitales',
			// level: "example",
			grade: 'Primaria',
			subject: 'Recursos digitales',
			video_title: this.content.name,
			video_id: this.content.urlContent,
			visible: true,
			cct: this.cct, //Dynamic data
			school_type: this.typeSchool,
		});
	}

	vodeoEnd(event: Event) {
		dataLayer.push({
			event: 'video_start',
			account_type: this.rol,
			content_group: 'Recursos digitales',
			grade: 'Primaria',
			subject: 'Recursos digitales',
			video_title: this.content.name,
			video_id: this.content.urlContent,
			visible: true,
			cct: this.cct, //Dynamic data
			school_type: this.typeSchool,
		});
	}

	vimeoIframeLoaded() {
		const iframe = this.videoFrame.nativeElement;

		// Envía un mensaje al iframe
		iframe.contentWindow.postMessage(
			'startPlayback',
			'https://unificacion2.azurewebsites.net/app/digital-resources'
		);

		// Puedes intentar acceder al video dentro del iframe y agregar eventos.
		const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;

		iframeDocument.addEventListener('DOMContentLoaded', () => {
			const videoElement = iframeDocument.querySelector('video');

			if (videoElement) {
				videoElement.addEventListener('play', () => {
					console.log('El video ha empezado a reproducirse.');
				});

				videoElement.addEventListener('ended', () => {
					console.log('El video ha terminado de reproducirse.');
				});
			}
		});
	}
	@HostListener('document:keydown', ['$event'])
	onKeyDown(event: KeyboardEvent): void {
		if (
			(event.ctrlKey && event.key === 's') ||
			(event.ctrlKey && event.key === 'p' && this.systemId === SYSTEMS.RA)
		) {
			event.preventDefault(); // Evita que el evento predeterminado (guardar o imprimir) ocurra
			event.stopPropagation(); // Detiene la propagación del evento
		}
	}

	public onBeforePrint() {
    /*
    debugger;
		let iframe = this.el.nativeElement.querySelector(
			'.ui-section-multimedia .document ng2-pdfjs-viewer iframe'
		);
		let iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
		let printContainer = iframeDocument.querySelector('#printContainer');
		let div = this.renderer.createElement('div');
		div.innerHTML = '<style type="text/css" media="print">* { display: none; }</style>';
		this.renderer.appendChild(printContainer, div);*/
	}

	getControlsList(): string {
		if (this.nodeId === 4404) {
			return ' noplaybackrate';
		} else {
			return 'nodownload noplaybackrate';
		}
	}

	downloadFile() {
		this.rs.downloadContent(this.content);
	}
}
